import { useCallback } from 'react';
export const mapConversationContext = (webChatConfig) => ({
    token: webChatConfig.directLineConfig.token,
    userId: webChatConfig.directLineConfig.userId,
    conversationId: webChatConfig.directLineConfig.conversationIdForToken,
    isResumed: webChatConfig.directLineConfig.continueConversation
});
export const usePostConversationStarted = (token) => useCallback(async (eventData) => {
    return await fetch('/api/events/conversationStarted', {
        method: 'POST',
        body: JSON.stringify(eventData),
        headers: {
            Authorization: `Bearer ${token.current}`,
            'Content-Type': 'application/json'
        }
    }).then((res) => res.json());
}, [token]);
//# sourceMappingURL=usePostConversationStarted.js.map